import { authenticatedFetch } from '../../api/request';

export default async function getLanguagesInProfile(setErrorMessage) {
    const onError = () => setErrorMessage('No se puede obtener los lenguajes del perfil.');
    return await authenticatedFetch('/doctor-profile/languages-in-profile', onError);
}
